/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoaderState } from './@theme/Loader/loader';
import { LoaderService } from './@theme/Loader/loader.service';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'ngx-app',
  styleUrls: ['./app.component.scss'],
  template: `
 
  <div [nbSpinner]=loading nbSpinnerStatus="danger" nbSpinnerSize="medium" nbSpinnerMessage="">
    <router-outlet></router-outlet>
  </div>
  <div class="alert alert-warning grdp" role="alert" [hidden]="!visible">
  <p>
    Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarle publicidad relacionada con sus preferencias mediante el análisis de sus hábitos de navegación. Si continúa navegando, consideramos que acepta su uso. Puede obtener más información, o bien conocer cómo cambiar la configuración, en nuestra <a style="color:#FF9999" href="#/public/politicaCookies" target="_blank">Política de cookies</a>
  </p>
  <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3" style="float:right">
    <button nbButton fullWidth size="small" shape="round" status="warning" class="reject-cookies" (click)="onReject()">Rechazar</button>
  </div>
  <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3" style="float:right">
    <button nbButton fullWidth size="small" shape="round" class="bcgrdp" (click)="onGRDP()">Aceptar</button>
  </div>
</div> 
<nb-layout>

<nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
 </nb-layout>

  `,
})
export class AppComponent implements OnInit {
  loading: boolean = false;
  cookieValue = 'UNKNOWN';
  visible: boolean = true;
  constructor(private spinner: NgxSpinnerService, private loaderService: LoaderService, private cookieService: CookieService) {
    this.spinner.show();
  }

  ngOnInit(): void {

    if (this.cookieService.get('gdpr_cookies') !== 'Acepta') {
      this.visible = true;
      
      this.cookieService.set('gdpr_cookies', 'EnEspera', null, "/", null, true);
    } else {
      this.visible = false;
    }
    this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        setTimeout(() => {
          this.loading = state.show;
        }, 0.5);
      });
  }

  @Output() close: EventEmitter<any> = new EventEmitter();
  onGRDP() {
    this.cookieService.set('gdpr_cookies', 'Acepta', null, "/", null, true);
    this.visible = !this.visible;
    if (this.visible) {
      this.close.emit(null);
    }
  }

  onReject() {
    this.visible = !this.visible;
    if (this.visible) {
      this.close.emit(null);
    }
  }

  politicaCookies() {
  }
}
